import React from 'react';
import { useForm } from 'react-hook-form';
import { mobileBrandQuery } from '../../../../services/react-query/optionMasterQuery';
import { handleSubmitForm } from '../func/handleSubmitForm';
import { useInsertModel } from '../hooks/useInsertModel';
import { FORM_INSERT_MODEL } from '../form';
import { ButtonTheme, ModalTheme, RenderForm } from '../../../../components';
import { ContainerButton } from '../../../../styles/global-style';

export const AddModel = ({ open, onToggle, onFetch }) => {
  const { control, setValue, getValues, handleSubmit } = useForm({ defaultValues: '' });

  const { data: mobileBrandList } = mobileBrandQuery();

  const { mutate: onSubmitInsertModel } = useInsertModel({
    onSuccessCallBack: onFetch,
  });

  const onSubmit = (values) => {
    handleSubmitForm(values, onSubmitInsertModel);
    onToggle({ defaultValues: '' });
  };

  return (
    <ModalTheme title="เพิ่มรุ่นมือถือ" open={open} onToggle={onToggle}>
      <RenderForm
        control={control}
        setValue={setValue}
        getValues={getValues}
        forms={FORM_INSERT_MODEL({ mobileBrandList })}
      />
      <ContainerButton right>
        <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
        <ButtonTheme useFor="CANCEL" onClick={onToggle} />
      </ContainerButton>
    </ModalTheme>
  );
};
